import {all, takeEvery, put, call, select} from 'redux-saga/effects';
import actions from "./actions"
import {
    getVehiclesApi,
    getLocationApi,
    getVehicleDetailsApi,
    getPinDetailsApi,
    getVehiclesLocationsApi,
    getVehicleLocationDetailsApi,
    getVehicleStartStop,
    getVehiclesSearch,
    getUserPoi,
    getUserPoiDetails,
    getCustomerPoi,
    getCustomerPoiDetails,
    getVehicleRpmApi,
    getVehiclesConfigurationApi,
    getVehicleGroupsApi,
    getVehiclesFromGroupApi,
    getVehicleGroupDetailsApi,
    getVehiclesUngroupedApi,
    getVehiclesNewStartStop,
    getVehiclesWithConfigurationApi,
    getTelemetryPdfApi,
    getRouteReportApi,
    getFuelTankVehicleApi,
    getFuelTankVehicleCombinedApi,
    getVehicleDisturbanceApi,
    getBottomOfTopBarApi,
} from "../../services/vehicles.service"
import {LocationInterface} from "./vehicles.type";
import {ReducerType} from "../reducer.type";
import moment from "moment";
import {
    telemetryVehiclesChoiceActive,
    telemetryVehiclesChoiceAll,
    telemetryVehiclesChoiceInactive
} from "../../constans";
import { AxiosResponse } from 'axios';
import { ClientWorkspace } from '../client/client.type';
import { WorkspaceType } from '../user/user.type';

const getWorkspace = (state: ReducerType) => state.client.owner.workspace;
const getActiveWorkspace = (state: ReducerType) => state.user.activeWorkspace;

export function* GET_VEHICLES(action: {payload: any, type:any}){
    try{
        const response: AxiosResponse<any> = yield call(getVehiclesApi, action.payload);
        if (response.data){
            yield put({
                type: actions.SET_DATA,
                payload: response.data
            })
        }
    }
    catch (e) {}
}

export function* GET_LOCATION(action:{payload: LocationInterface, type: string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getLocationApi,
          action.payload
        );
        if (response.data){
            yield put({
                type: actions.SET_LOCATION,
                payload: response.data
            })
        }
    }
    catch (e) {}
}

export function* GET_VEHICLE_DETAILS(action:{payload: any, type:string}){
    try{
        const { vehicle_id, workspaceUuid } = action.payload;
        const response: AxiosResponse<any> = yield call(
          getVehicleDetailsApi,
          workspaceUuid,
          vehicle_id
        );
        if(response.data){
            yield put({
                type: actions.SET_VEHICLE_DETAILS,
                payload: response.data
            })
        }
    } catch (e) { }
}

export function* GET_PIN_DETAILS(action:{payload: string, type: string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getPinDetailsApi,
          action.payload
        );
        if (response.data){
            yield put({
                type: actions.SET_PIN_DETAILS,
                payload: response.data
            })
        }
    } catch (e) { }
}

export function* GET_VEHICLES_LOCATIONS(action:{payload: string, type: string}) {
    try{
        const response: AxiosResponse<any> = yield call(
          getVehiclesLocationsApi,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_VEHICLES_LOCATIONS,
                payload: response.data
            })
        }
    } catch (e) {}

}

export function* GET_VEHICLE_LOCATION_DETAILS(action:{payload:any, type:string}) {
    try{
        const { uuid, vehicle_id } = action.payload;
        const response: AxiosResponse<any> = yield call(
          getVehicleLocationDetailsApi,
          uuid,
          vehicle_id
        ); //fixfix
        if(response.data){
            yield put({
                type:actions.SET_VEHICLE_LOCATION_DETAILS,
                payload:response.data
            })
        }
    } catch (e) {
    }
}

export function* GET_USER_POI(action:{payload:string, type:string}){
    try {
        const response: AxiosResponse<any> = yield call(
          getUserPoi,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_USER_POI,
                payload: response.data
            })
        }
    } catch (e) {}
}

export function* GET_USER_POI_DETAILS(action:{payload: string, type:string}) {
    try {
        const response: AxiosResponse<any> = yield call(
          getUserPoiDetails,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_USER_POI_DETAILS,
                payload: response.data
            })
        }
    } catch (e) {
    }
}
export function* GET_VEHICLES_SEARCH(action:{payload: any, type:string}){
    try{
        const { workspaceUuid, query } = action.payload;
        const response: AxiosResponse<any> = yield call(
          getVehiclesSearch,
          workspaceUuid,
          query
        );

        let combinedData:any = [];
        yield response.data.forEach((item: any, index: number) => {
            const obj = {
                ...response.data[index]["0"],
                configuration: {
                    ...response.data[index],
                }
            };
            delete obj.configuration['0'];
            combinedData.push(obj)
        });

        if (response.data){
            yield put({
                type: actions.SET_VEHICLES_SEARCH,
                payload: combinedData
            })
        }
    } catch (e) {

    }
}

export function* GET_VEHICLE_START_STOP(action:{payload: any, type:string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getVehicleStartStop,
          action.payload
        );
        if (response.data){
            yield put({
                type: actions.SET_VEHICLE_START_STOP,
                payload: response.data
            })
        }
    } catch (e) {

    }
}

export function* GET_VEHICLE_NEW_START_STOP(action:{payload: any, type:string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getVehiclesNewStartStop,
          action.payload
        );
        if (response) yield put({
                type: actions.SET_VEHICLE_NEW_START_STOP,
                payload: response.data
        })
    } catch (e) {
        console.log(e)
    }
}

export function* GET_CUSTOMER_POI(action: {payload: string, type: string}){
    try {
        const items: ClientWorkspace = yield select(getWorkspace);
        const response: AxiosResponse<any> = yield call(
          getCustomerPoi,
          items ? items.uuid : action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_CUSTOMER_POI,
                payload: response.data
            })
        }
    } catch (e) {}
}

export function* GET_CUSTOMER_POI_DETAILS(action: {payload: string, type: string}){
    try {
        // const items = yield select(getWorkspace);
        // const response = yield call(getCustomerPoiDetails, items ? items.uuid : action.payload);
        const response: AxiosResponse<any> = yield call(
          getCustomerPoiDetails,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_CUSTOMER_POI_DETAILS,
                payload: response.data
            })
        }
    } catch (e) {}
}

export function* GET_VEHICLE_RPM(action: {payload: any, type: string}){
    try {
        const response: AxiosResponse<any> = yield call(
          getVehicleRpmApi,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_VEHICLE_RPM,
                payload: response.data
            })
        }
    } catch (e) {}
}

export function* GET_VEHICLES_CONFIGURATION(action: {payload: string, type:string}){
    try {
        const items: ClientWorkspace = yield select(getWorkspace);
        const response: AxiosResponse<any> = yield call(
          getVehiclesConfigurationApi,
          items ? items.uuid : action.payload
        );
        if (response.data){
            yield put({
                type: actions.SET_VEHICLES_CONFIGURATION,
                payload: response.data
            })
        }
    } catch (e) {
    }
}

export function* GET_VEHICLE_GROUPS(){
    try {
        const activeWorkspace: WorkspaceType = yield select(getActiveWorkspace);
        const response: AxiosResponse<any> = yield call(
          getVehicleGroupsApi,
          activeWorkspace.uuid
        );
        if(response.data){
            yield put({
                type: actions.SET_VEHICLE_GROUPS,
                payload: response.data
            })
        }
    } catch (e) {}
}

export function* GET_VEHICLES_GROUP(action: {payload: string, type: string}){
    try {
        const activeWorkspace: WorkspaceType = yield select(getActiveWorkspace);
        const response: AxiosResponse<any> = yield call(
          getVehiclesFromGroupApi,
          activeWorkspace.uuid,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_VEHICLES_GROUP,
                payload: response.data
            })
        }
    } catch (e) {}
}

export function* GET_VEHICLES_GROUP_DETAILS(action: {payload: string, type: string}){
    try {
        const activeWorkspace: WorkspaceType = yield select(getActiveWorkspace);
        const response: AxiosResponse<any> = yield call(
          getVehicleGroupDetailsApi,
          activeWorkspace.uuid,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_VEHICLE_DETAILS_GROUP,
                payload: response.data
            })
        }
    } catch (e) {}
}

export function* GET_VEHICLES_UNGROUPED(){
    try {
        const activeWorkspace: WorkspaceType = yield select(getActiveWorkspace);
        const response: AxiosResponse<any> = yield call(
          getVehiclesUngroupedApi,
          activeWorkspace.uuid
        );
        const combinedData:any = [];
        yield response.data.forEach((item: any, index: number) => {
            const obj = {
                ...response.data[index]["0"],
                configuration: {
                    ...response.data[index],
                }
            };
            delete obj.configuration['0'];
            combinedData.push(obj)
        });
        if(response){
            yield put({
                type: actions.SET_VEHICLES_UNGROUPED,
                payload: combinedData
            })
        }
    } catch (e) {}
}

export function* GET_VEHICLES_WITH_CONFIGURATION(){
    try {
        const activeWorkspace: WorkspaceType = yield select(getActiveWorkspace);
        const response: AxiosResponse<any> = yield call(
          getVehiclesWithConfigurationApi,
          activeWorkspace.uuid
        );
        let combinedData:any = [];
        yield response.data.forEach((item: any, index: number) => {
            const obj = {
                ...response.data[index]["0"],
                configuration: {
                    ...response.data[index],
                }
            };
            delete obj.configuration['0'];
            combinedData.push(obj)
        });
        if(response.data){
            yield put({
                type: actions.SET_VEHICLES_WITH_CONFIG,
                payload: combinedData
            })
        }
    }
    catch (e) {}
}

export function* GET_TELEMETRY_PDF(action: {payload: { choice: string|null, map_image: string }, type: string}){
    try {
        const getChoice = () => {
            switch (action.payload.choice){
                case telemetryVehiclesChoiceAll:
                    return "Pojazdy";
                case telemetryVehiclesChoiceActive:
                    return "W trasie";
                case telemetryVehiclesChoiceInactive:
                    return "Postój";
                default:
            }
        };
        const title: string = `Bieżąca telemetria - ${getChoice()} - ${moment().format("DD-MM-YYYY HH:mm")} `;
        const activeWorkspace: WorkspaceType = yield select(getActiveWorkspace);
        yield call(getTelemetryPdfApi, activeWorkspace.uuid, action.payload.choice, action.payload.map_image, title )
    }
    catch (e) {}
}

export function* GET_ROUTE_REPORT_PDF(action: {payload: {
        vehicle_id: string,
        start_date: string
        end_date: string,
        title: string,
        first_chart: string,
        fuel_chart_1: string | null,
        fuel_chart_2: string | null,
        fuel_chart_3: string | null,
        fuel_chart_4: string | null,
        fuel_chart_5: string | null,
        fuel_chart_6: string | null,
        fuel_chart_7: string | null,
        fuel_chart_8: string | null,
        second_chart: string,
        first_choice: string|null,
        second_choice: string
    } , type: any}){
    const { vehicle_id, end_date, start_date, title,  first_chart, second_chart, first_choice, second_choice, fuel_chart_1, fuel_chart_2, fuel_chart_3, fuel_chart_4, fuel_chart_5, fuel_chart_6, fuel_chart_7, fuel_chart_8 } = action.payload;

    const query = {
        vehicle_id,
        start_date,
        end_date,
    };
    try {
        const activeWorkspace: WorkspaceType = yield select(getActiveWorkspace);
        // @ts-ignore
        yield call(getRouteReportApi, activeWorkspace.uuid, first_chart,second_chart,first_choice,second_choice, query, title, fuel_chart_1, fuel_chart_2, fuel_chart_3, fuel_chart_4, fuel_chart_5, fuel_chart_6, fuel_chart_7, fuel_chart_8 );
        yield put({
            type: actions.SET_PDF_LOADING,
            payload: false
        })
    }
    catch (e) {
        yield put({
            type: actions.SET_PDF_LOADING,
            payload: false
        })
    }
}

export function* GET_FUEL_TANK_VEHICLE(action: {payload: any, type: any}){
    try {
        // const activeWorkspace = yield select(getActiveWorkspace);
        const response: AxiosResponse<any> = yield call(
          getFuelTankVehicleApi,
          action.payload
        );
        if (response.data) {
            yield put({
                type: actions.SET_VEHICLES_FUEL_TANK_VEHICLE,
                payload: response.data
            })
        }
    } catch (e) {}
}

export function* GET_FUEL_TANK_VEHICLE_COMBINED(action: {payload: any, type: any}){
    try {
        // const activeWorkspace = yield select(getActiveWorkspace);
        const response: AxiosResponse<any> = yield call(
          getFuelTankVehicleCombinedApi,
          action.payload
        );
        if (response.data) {
            yield put({
                type: actions.SET_VEHICLES_FUEL_TANK_VEHICLE_COMBINED,
                payload: response.data
            })
        }
    } catch (e) {}
}

export function* GET_VEHICLE_DISTURBANCE_REFUEL(action: {payload: any, type: any}) {
    try {
        const response: AxiosResponse<any> = yield call(
          getVehicleDisturbanceApi,
          action.payload
        );
        if (response.data) {
            yield put({
                type: actions.SET_VEHICLE_DISTURBANCE_REFUEL,
                payload: response.data
            })
        }
    } catch (e) { }
}

export function* GET_VEHICLE_DISTURBANCE_LOSS(action: {payload: any, type: any}) {
    try {
        const response: AxiosResponse<any> = yield call(
          getVehicleDisturbanceApi,
          action.payload
        );
        if (response.data) {
            yield put({
                type: actions.SET_VEHICLE_DISTURBANCE_LOSS,
                payload: response.data
            })
        }
    } catch (e) { }
}

export function* GET_TOP_BAR_BOTTOM(action:{ payload: any, type: any}) {
    try {
        const response: AxiosResponse<any> = yield call(
          getBottomOfTopBarApi,
          action.payload
        );
        if(response.data) {
            yield put({
                type: actions.SET_BOTTOM_OF_TOP_BAR,
                payload: response.data
            })
        }
    } catch (e) {

    }
}

export default function* RootSaga(){
    yield all([
        takeEvery(actions.GET_DATA, GET_VEHICLES),
        takeEvery(actions.GET_LOCATION, GET_LOCATION),
        takeEvery(actions.GET_VEHICLE_DETAILS, GET_VEHICLE_DETAILS),
        takeEvery(actions.GET_PIN_DETAILS, GET_PIN_DETAILS),
        takeEvery(actions.GET_VEHICLES_LOCATIONS, GET_VEHICLES_LOCATIONS),
        takeEvery(actions.GET_VEHICLE_LOCATION_DETAILS, GET_VEHICLE_LOCATION_DETAILS),
        takeEvery(actions.GET_USER_POI, GET_USER_POI),
        takeEvery(actions.GET_USER_POI_DETAILS, GET_USER_POI_DETAILS),
        takeEvery(actions.GET_VEHICLES_SEARCH, GET_VEHICLES_SEARCH),
        takeEvery(actions.GET_VEHICLE_START_STOP, GET_VEHICLE_START_STOP),
        takeEvery(actions.GET_CUSTOMER_POI, GET_CUSTOMER_POI),
        takeEvery(actions.GET_CUSTOMER_POI_DETAILS, GET_CUSTOMER_POI_DETAILS),
        takeEvery(actions.GET_VEHICLE_RPM, GET_VEHICLE_RPM),
        takeEvery(actions.GET_VEHICLES_CONFIGURATION, GET_VEHICLES_CONFIGURATION),
        takeEvery(actions.GET_VEHICLE_GROUPS, GET_VEHICLE_GROUPS),
        takeEvery(actions.GET_VEHICLES_GROUP, GET_VEHICLES_GROUP),
        takeEvery(actions.GET_VEHICLE_DETAILS_GROUP, GET_VEHICLES_GROUP_DETAILS),
        takeEvery(actions.GET_VEHICLES_UNGROUPED, GET_VEHICLES_UNGROUPED),
        takeEvery(actions.GET_VEHICLE_NEW_START_STOP, GET_VEHICLE_NEW_START_STOP),
        takeEvery(actions.GET_VEHICLES_WITH_CONFIG, GET_VEHICLES_WITH_CONFIGURATION),
        takeEvery(actions.GET_TELEMETRY_PDF, GET_TELEMETRY_PDF),
        takeEvery(actions.GET_ROUTE_REPORT_PDF, GET_ROUTE_REPORT_PDF),
        takeEvery(actions.GET_VEHICLES_FUEL_TANK_VEHICLE, GET_FUEL_TANK_VEHICLE),
        takeEvery(actions.GET_VEHICLES_FUEL_TANK_VEHICLE_COMBINED, GET_FUEL_TANK_VEHICLE_COMBINED),
        takeEvery(actions.GET_VEHICLE_DISTURBANCE_REFUEL, GET_VEHICLE_DISTURBANCE_REFUEL),
        takeEvery(actions.GET_VEHICLE_DISTURBANCE_LOSS, GET_VEHICLE_DISTURBANCE_LOSS),
        takeEvery(actions.GET_BOTTOM_OF_TOP_BAR, GET_TOP_BAR_BOTTOM),
    ])
}